import { globalStyleObj } from "@/app/assets/styles";
import {
  AboutUsCommonSectionFormFields,
  LabelText,
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextEditorInputFiled,
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import { Skeleton } from "@/components/ui/skeleton";
import { useMemo } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";

const AboutPageCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* Common Section Form Fields */}
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Common Banner Image"
              fieldId="about-us-common-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("about-us-common-banner-image", id)
                  : handleImageChange("about-us-common-banner-image", "")
              }
              selectedFileId={formData?.["about-us-common-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Common Banner Heading"
            fieldId="about-us-common-banner-heading"
            fieldName="about-us-common-banner-heading"
            placeholderText="Heading"
            inputValue={formData?.["about-us-common-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Common Banner Description"
            fieldId="about-us-common-banner-heading"
            fieldName="about-us-common-banner-description"
            placeholderText="Description"
            inputValue={formData?.["about-us-common-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Tabs */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            labelText="Main Tabs"
            fieldId="about-us-common-tabs"
            handleTextInputChange={handleTextInputChange}
            // handleTextEditorInputChange={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "about-us-tab-card-1",
                types: ["TEXT", "TEXT", "TEXT", "TEXT", "TEXT"],
                is_hidden: [true, true, true, true, true],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                  "text_filed_id_4",
                  "text_filed_id_5",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                  "text_filed_placeholder_4",
                  "text_filed_placeholder_5",
                ],
                // IDs
                text_filed_id_1: "about-us-tab-label-1",
                text_filed_id_2: "about-us-tab-label-2",
                text_filed_id_3: "about-us-tab-label-3",
                text_filed_id_4: "about-us-tab-label-4",
                text_filed_id_5: "about-us-tab-label-5",
                // Placeholders
                text_filed_placeholder_1: "Tab Name 1",
                text_filed_placeholder_2: "Tab Name 2",
                text_filed_placeholder_3: "Tab Name 3",
                text_filed_placeholder_4: "Tab Name 4",
                text_filed_placeholder_5: "Tab Name 5",
              },
            ]}
          />
        </>
      )}
    </>
  );
};

export default AboutPageCMSForm;
